import React from "react";

import { useAppSelector } from "store";
import {
    chooseAllStoreSizes,
    deselectAllStoreSizes,
    selectStoreSizes,
    toggleStoreSizeIsSelected
} from "modules/customer/insights/portfolioNew/areaHealthNew/areaHealthNewSlice";
import MultiSelectFilter from "components/filters/MultiSelectFilter";

const StoreSizeFilter: React.FC = () => {
    const storeSizes = useAppSelector(selectStoreSizes);
    return (
        <MultiSelectFilter
            title="Store size"
            items={storeSizes}
            chooseAllItems={chooseAllStoreSizes}
            deselectAllItems={deselectAllStoreSizes}
            toggleItemIsSelected={toggleStoreSizeIsSelected}
        />
    );
};

export default StoreSizeFilter;
